import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25.703 27.608" {...props}><path fill="none" stroke="currentColor" strokeWidth="2" d="M16.5 18.5l8.5 8.397M1 11C1 5.475 5.475 1 11 1s10 4.475 10 10-4.475 10-10 10S1 16.525 1 11z" /></svg>);